import { InitializeScdHandlers } from "@lib/scd/ScdSelectorClientside";
import { vacancyBoardFilterSchema } from "./types";
import htmx from "htmx.org";
import { ZodFormValidationDisplay } from "@lib/validation/utils";

export async function onSearchValidation(event: Event, pageNumber: number = 1) {
    const validationErrors = document.querySelectorAll('.field-validation-error');
    validationErrors.forEach(item => item.remove());

    const form = document.querySelector('#filter') as HTMLFormElement;
    const data = Object.fromEntries(new FormData(form));

    try {
        const res = await vacancyBoardFilterSchema.parseAsync(data);
        htmx.ajax('POST', '/public/shared/vacancy-board-project?pageNumber=' + pageNumber,  
            {
                values: data, 
                target: '#projects-board-results'
            }
        );
    } catch (error) {
        event.stopPropagation();
        event.preventDefault();
        
        ZodFormValidationDisplay(JSON.parse(error));
    }
}

function onSearchInhouseValidation(event: Event, pageNumber: number = 1) {
    htmx.ajax('POST', '/public/shared/vacancy-board-inhouse?pageNumber=' + pageNumber,  
        {
            values: { "PageNumber": pageNumber },
            target: '#inhouse-board-results'
        }
    );   
}

export function OnPagingChange(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    const section = document.querySelector('.tab-search__link.active') as HTMLElement;

    const pageNumber = (event.currentTarget as HTMLButtonElement).dataset.id;
    if (section.dataset.panel == "projects") {
        onSearchValidation(event, pageNumber !== undefined ? parseInt(pageNumber) : 1);
        return;
    }

    onSearchInhouseValidation(event, pageNumber !== undefined ? parseInt(pageNumber) : 1);
}


function Initialize() {
    const tabButtons = document.querySelectorAll(".tab-search__item") as NodeListOf<HTMLElement>;
    tabButtons.forEach(item => item.addEventListener("click", (event) => {
        const filterElement = document.querySelector('.projectsBoard__filter') as HTMLElement;
        filterElement.style.display = 'block';        
        filterElement.style.display = item.dataset.panel === 'inhouse' ? 'none' : 'block';
    }));
}

InitializeScdHandlers();
Initialize();